import { render, staticRenderFns } from "./PartialVendor.vue?vue&type=template&id=4cbcf083&scoped=true&lang=html"
import script from "./PartialVendor.vue?vue&type=script&lang=js"
export * from "./PartialVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbcf083",
  null
  
)

export default component.exports